import React, { FC } from 'react';
import { Typography } from '@material-ui/core';
import { createStyles, WithStyles, withStyles } from '@material-ui/core/styles';

import { UrlMetadata } from 'api';

const styles = () =>
  createStyles({
    description: {
      marginBottom: 12,
    },
  });

interface IProps extends WithStyles<typeof styles> {
  description: UrlMetadata['description'];
}

const Description: FC<IProps> = ({ classes, description }) => (
  <Typography className={classes.description}>{description}</Typography>
);

export default withStyles(styles)(Description);
